import onDocumentLoad from './helpers/on-document-load';
import { UIController } from './controllers/ui.controller';
import { NavController } from './controllers/nav.controller';
import { HomeController } from './controllers/home.controller';

export const APP = {
  init() {
    return Promise.all([UIController.init(), NavController.init(), HomeController.init()]);
  },
};

onDocumentLoad(APP.init);
